document.addEventListener("DOMContentLoaded", () => {
    const leaflets = document.querySelectorAll(".archive-leaflet");

    if (leaflets.length > 0) {
        leaflets.forEach((leaflet) => {
            const topDiv = leaflet.querySelector(".top");
            const itemText = leaflet.querySelector(".archive-item-text");
            const toggleIcon = leaflet.querySelector(".toggle-icon");

            topDiv.addEventListener("click", (e) => {
                e.stopPropagation()
                const isActive = topDiv.classList.contains("active");

                topDiv.classList.toggle("active", !isActive);

                if (isActive) {
                    itemText.style.maxHeight = "0px";
                } else {
                    itemText.style.maxHeight = `${itemText.scrollHeight}px`;
                }

                const currentSrc = toggleIcon.src;
                const newSrc = currentSrc.includes("plus.svg")
                    ? currentSrc.replace("plus.svg", "minus.svg")
                    : currentSrc.replace("minus.svg", "plus.svg");

                toggleIcon.src = newSrc;
            });
        });
    }
});